import axios from "axios";

const moduleCategoryMaster = {
  namespaced: true,
  state: {
    categoryList: [],
    createCategoryItem: null,
  },
  mutations: {
    setCategoryList(state, data) {
      state.categoryList = data;
    },
  },
  actions: {
    async fetchCategoryList({ commit }, { clinicUrl, branchUrl }) {
      try {
        const res = await axios.get(
          `/api/master/mProductCate/${clinicUrl}/${branchUrl}`
        );
        const items = res.data.data.map(i => ({
          categoryId: i.id,
          categoryCode: i.code,
          categoryNameTh: i.description,
          categoryNameEn: i.description2,
          categoryStatus: i.status,
          creationDt: i.creationDt,
        }));
        commit("setCategoryList", items);
        return items;
      } catch (err) {
        console.error("fetchCategoryList failed", err);
        throw err;
      }
    },
    createCategoryItem({ commit, getters }, payload) {
      return axios
        .post(
          `/api/master/mProductCate/${payload.clinicUrl}/${payload.branchUrl}`,
          payload.adjustCategoryItem,
          {
            skipGlobalErrorHandler: true,
          }
        )
        .then(res => {
          return res;
        })
        .catch(err => {
          throw err;
        });
    },

    updateCategoryItem({ commit, getters }, payload) {
      return axios
        .put(
          `/api/master/mProductCate/${payload.clinicUrl}/${payload.branchUrl}/${payload.id}`,
          payload.adjustCategoryItem,
          {
            skipGlobalErrorHandler: true,
          }
        )
        .then(res => {
          return res;
        })
        .catch(err => {
          throw err;
        });
    },

    deleteCategoryItem({ commit, getters }, payload) {
      return axios
        .delete(
          `/api/master/mProductCate/${payload.clinicUrl}/${payload.branchUrl}/${payload.id}`,
          {
            skipGlobalErrorHandler: true,
          }
        )
        .then(res => {
          return res;
        })
        .catch(err => {
          throw err;
        });
    },
  },
  getters: {
    getCategoryList: state => {
      return state.categoryList;
    },
  },
};

export default moduleCategoryMaster;
